export enum InstructionStateStatus {
  INACTIVE = 'inactive',
  RUNNING = 'running',
  PAUSED = 'paused',
  WAITING = 'waiting',
}

export interface InstructionState {
  status: InstructionStateStatus;
  subInstructionState: {
    activeStateName?: string;
    activeRobotKeyFrameID?: number;
    activeSequence?: string;
  };
}